import { Injectable, computed, inject, signal } from '@angular/core';
import { DroplistItem } from '@eforall/dashboard';
import { TrimesterWindow, TrimesterWindowEnum } from '@interfaces';
import { AppService, FuncService } from '..';


@Injectable({ providedIn: 'root' })
export class TrimesterService {

	private readonly func = inject(FuncService);
	private readonly app = inject(AppService);
	private trimesterWindow = signal<TrimesterWindow | undefined>(undefined);
	public readonly selectedTrimesterDropdownOption = signal<DroplistItem | undefined>(undefined);
	trimesterWindowOptionMap: Record<TrimesterWindow, DroplistItem | undefined> = {
		'Admissions': undefined,
		'Programming': undefined
	};
	private readonly loadedTrimesters = signal<boolean>(false);

	public readonly allTrimesterData = computed(() => this.app.data().trimesters);

	public items = computed<DroplistItem<never, number>[]>(() => {
		const trimesterWindow = this.trimesterWindow();

		const result: DroplistItem<never, number>[] = (this.allTrimesterData() || []).map(({ trimesterId, name }, i) => ({
			uniqueId: trimesterId,
			iconContext: {
				iconClass: 'fa-calendar-range',
				iconStyle: 'fa-solid',
				text: name + " " + (trimesterWindow === TrimesterWindowEnum.Admissions ? 'Admissions' : 'Program Delivery'),
				hideText: 'never',
			},
			customSort: i + 1
		}));
		return result;
	});

	public readonly selectedTrimester = computed(() => {
		const selectedId = this.selectedTrimesterDropdownOption()?.uniqueId;
		return selectedId ? this.allTrimesterData().find(item => item.trimesterId === selectedId) : undefined;
	});


	public async loadData(trimesterWindow: TrimesterWindow) {
		if (!this.items().length) return;

		if (!this.loadedTrimesters()) {
			await this.setInitialTrimesterSpecificOption(TrimesterWindowEnum.Admissions);
			await this.setInitialTrimesterSpecificOption(TrimesterWindowEnum.Programming);
			this.loadedTrimesters.set(true);
		}

		if (this.trimesterWindow() !== trimesterWindow) {
			this.selectedTrimesterDropdownOption.set(this.trimesterWindowOptionMap[trimesterWindow]);
			this.trimesterWindow.set(trimesterWindow);
		}
	}

	async setInitialTrimesterSpecificOption(trimesterWindow: TrimesterWindow) {
		const data = await this.func.trimesters.getCurrentTrimester({ trimesterWindow });
		this.trimesterWindowOptionMap[trimesterWindow] = this.items().find(i => i.uniqueId === data?.trimesterId);
	}

	onViewDroplistChange(selectedView: DroplistItem | undefined) {
		if (selectedView) {
			this.selectedTrimesterDropdownOption.set(selectedView);
			const trimesterWindow = this.trimesterWindow();
			if (trimesterWindow) {
				this.trimesterWindowOptionMap[trimesterWindow] = selectedView;
			}
		}
	}
}